var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useMonitorEngineContext } from "@nibfe/mcp-monitor-sdk";
import { useRequest } from "./useRequest";
import { API_PATH } from "./useRequest";
export function useInvite(options) {
    const ctx = useMonitorEngineContext();
    const { requestStatus, request } = useRequest(API_PATH.INVITE, {
        method: 'POST',
        raw: true,
        showLoading: true
    });
    // 执行邀请助力
    function doInvite(requresParams) {
        var _a, _b, _c, _d, _e, _f;
        return __awaiter(this, void 0, void 0, function* () {
            const { leaderId, followerId, cityId, lastWishTime, taskId } = requresParams;
            try {
                const rawRes = yield request(Object.assign(Object.assign({}, options), { leaderId: Number(leaderId), followerId: Number(followerId), cityId: Number(cityId), lastWishTime: Number(lastWishTime), taskId: Number(taskId) || options.taskId }));
                console.log('rawRes', rawRes);
                if (!rawRes || !rawRes.data) {
                    throw new Error('助力接口失败');
                }
                const res = rawRes.data;
                if (res.code === 0) {
                    (_b = (_a = ctx._raptorReport).monitorReportBizSuccess) === null || _b === void 0 ? void 0 : _b.call(_a);
                    return {
                        success: true,
                        message: '助力接口成功'
                    };
                }
                else {
                    // 接口调用失败
                    (_d = (_c = ctx._raptorReport).monitorReportBizFailed) === null || _d === void 0 ? void 0 : _d.call(_c);
                    return {
                        success: false,
                        message: res.message || '助力接口失败',
                        code: res.code
                    };
                }
            }
            catch (error) {
                // ctx._uiInteractionAPI.toast.show({
                //   content: '网络开小差了，请重试',
                // });
                (_f = (_e = ctx._raptorReport).monitorReportBizFailed) === null || _f === void 0 ? void 0 : _f.call(_e);
                ctx._raptorReport.monitorReportLog(error.message, error, {
                    category: 'ajaxError',
                    level: 'error'
                });
                return {
                    success: false,
                    message: '网络开小差了，请重试',
                    code: error.code
                };
            }
        });
    }
    return {
        doInvite,
        requestStatus
    };
}
